import React from 'react';
import { Info } from 'lucide-react';

// Small, subtle disclosure shown near the results area while Cheapora's
// upstream providers are still in their integration phase. Never displays
// on empty / no-provider states. Not a full-width banner — just a single
// muted line that respects the existing metasearch design.
export default function IndicativeResultsNotice({ className = '' }) {
  return (
    <div
      data-testid="indicative-results-notice"
      className={`mt-2 mb-3 flex items-start gap-2 text-[11px] text-slate-500 ${className}`}
    >
      <Info className="w-3.5 h-3.5 mt-0.5 shrink-0 text-slate-400" />
      <span>
        <span className="font-medium text-slate-600">Indicative results · Live booking availability coming soon.</span>{' '}
        <span className="text-slate-500">
          Prices and availability shown during our provider integration phase are indicative and may not reflect current bookable availability.
        </span>
      </span>
    </div>
  );
}
